import { COMPANY } from './company.data';

export const TERMS_DOC = {
  title: 'Termos de Uso',
  subtitle: `Condições de uso da plataforma ${COMPANY.tradeName}`,
  lastUpdated: COMPANY.lastUpdated,
  sections: [
    {
      title: 'Aceitação dos Termos',
      blocks: [
        {
          type: 'p',
          text:
            `Estes Termos de Uso ("Termos") regulam o acesso e a utilização do site ${COMPANY.domain} ` +
            `e dos serviços oferecidos pela ${COMPANY.legalName}, inscrita no CNPJ nº ${COMPANY.cnpj}, ` +
            `com sede em ${COMPANY.address} ("${COMPANY.tradeName}", "plataforma", "nós").`,
        },
        {
          type: 'p',
          text:
            'Ao acessar o site, realizar uma cotação ou concluir uma compra, o usuário declara que leu, ' +
            'compreendeu e concorda integralmente com estes Termos e com a Política de Privacidade. ' +
            'Caso não concorde, o usuário não deve utilizar a plataforma.',
        },
      ],
    },
    {
      title: 'Quem somos e o que a plataforma faz',
      blocks: [
        {
          type: 'p',
          text:
            `A ${COMPANY.tradeName} é uma plataforma digital que atua exclusivamente como ` +
            'intermediadora e canal de venda, permitindo que o usuário compare e contrate seguros ' +
            'viagem oferecidos por seguradoras e empresas de assistência parceiras (como Assist Card, ' +
            'Universal Assistance e Affinity).',
        },
        {
          type: 'p',
          text:
            'Nosso papel se limita a: (i) apresentar as opções de seguro viagem disponíveis; ' +
            '(ii) exibir preços e coberturas informados pelas seguradoras parceiras; e (iii) ' +
            'facilitar a contratação, encaminhando os dados da compra à seguradora escolhida para ' +
            'que ela emita a apólice.',
        },
      ],
    },
    {
      title: 'O que a plataforma NÃO é (limites da nossa atuação)',
      blocks: [
        {
          type: 'p',
          text:
            'Para que não haja dúvidas sobre a nossa responsabilidade, o usuário reconhece e concorda ' +
            `expressamente que a ${COMPANY.tradeName}:`,
        },
        {
          type: 'list',
          items: [
            'NÃO é uma seguradora e não assume qualquer risco relativo ao seguro contratado;',
            'NÃO é responsável pelo pagamento de indenizações, reembolsos, ressarcimentos ou qualquer valor decorrente do seguro;',
            'NÃO presta o serviço de assistência ao viajante — este é prestado integralmente pela seguradora;',
            'NÃO decide sobre coberturas, exclusões, aprovação ou negativa de sinistros, que são de responsabilidade exclusiva da seguradora;',
            'NÃO garante a emissão da apólice, que depende da análise e aceitação da seguradora parceira.',
          ],
        },
        {
          type: 'p',
          text:
            'O contrato de seguro é celebrado diretamente entre o usuário e a seguradora escolhida. ' +
            'As condições gerais, coberturas, limites, franquias e exclusões constam na apólice e nas ' +
            'condições contratuais fornecidas pela seguradora, que o usuário deve ler antes de contratar.',
        },
      ],
    },
    {
      title: 'Como funciona a contratação',
      blocks: [
        {
          type: 'list',
          items: [
            'O usuário informa os dados da viagem (datas, destino, idade dos passageiros) e recebe as opções de seguro disponíveis;',
            'O usuário escolhe a opção desejada e informa os dados dos passageiros/segurados e os dados de pagamento;',
            'O pagamento é processado por meio do checkout da seguradora/empresa de assistência ou de seus meios de pagamento;',
            'Após a confirmação, a apólice é emitida e enviada ao usuário diretamente pela seguradora, por e-mail ou disponibilizada para download.',
          ],
        },
        {
          type: 'p',
          text:
            'Eventuais valores cobrados correspondem ao prêmio do seguro definido pela seguradora. ' +
            `A remuneração da ${COMPANY.tradeName} decorre de comissão paga pela seguradora e não representa ` +
            'custo adicional ao usuário além do preço informado no momento da compra.',
        },
        {
          type: 'p',
          text:
            'Antes de confirmar a compra, o usuário deve conferir todas as informações (dados dos passageiros, ' +
            'datas, destino, cobertura e valor). Alguns campos podem ser preenchidos automaticamente para sua ' +
            'comodidade (por exemplo, o endereço a partir do CEP), mas a conferência final é de responsabilidade ' +
            'do usuário. Identificado qualquer erro, ele deve corrigir antes de concluir ou comunicar a ' +
            `${COMPANY.tradeName} o quanto antes.`,
        },
      ],
    },
    {
      title: 'Sinistro, assistência, cancelamento e reembolso',
      blocks: [
        {
          type: 'p',
          text:
            'Em caso de necessidade de acionamento do seguro (sinistro), pedido de assistência durante a ' +
            'viagem, cancelamento ou reembolso, o usuário deve entrar em contato diretamente com a ' +
            'seguradora responsável pela apólice, pelos canais de atendimento informados na própria apólice ' +
            'e nas páginas das seguradoras neste site.',
        },
        {
          type: 'p',
          text:
            `A ${COMPANY.tradeName} pode, a título de cortesia, auxiliar o usuário a localizar os canais de ` +
            'atendimento da seguradora, mas não tem ingerência sobre a análise, aprovação, prazos ou pagamento ' +
            'de qualquer solicitação, que são de responsabilidade exclusiva da seguradora.',
        },
      ],
    },
    {
      title: 'Cadastro e responsabilidades do usuário',
      blocks: [
        {
          type: 'p',
          text: 'Ao utilizar a plataforma, o usuário se compromete a:',
        },
        {
          type: 'list',
          items: [
            'Fornecer informações verdadeiras, completas e atualizadas, próprias ou de terceiros para quem esteja autorizado a contratar;',
            'Ser maior de 18 anos ou estar devidamente representado/assistido por responsável legal;',
            'Manter a confidencialidade de suas credenciais de acesso, quando houver cadastro;',
            'Utilizar a plataforma de forma lícita, sem praticar fraudes ou fornecer dados de terceiros sem autorização.',
          ],
        },
        {
          type: 'p',
          text:
            'O usuário é o único responsável pela veracidade dos dados informados. Informações incorretas ou ' +
            'incompletas podem inviabilizar a emissão da apólice ou o acionamento do seguro, sem que isso gere ' +
            `qualquer responsabilidade à ${COMPANY.tradeName}.`,
        },
      ],
    },
    {
      title: 'Propriedade intelectual',
      blocks: [
        {
          type: 'p',
          text:
            `Todo o conteúdo da plataforma — incluindo marca, logotipo, textos, layout, imagens e código — ` +
            `pertence à ${COMPANY.tradeName} ou a seus parceiros e licenciadores, sendo protegido pela ` +
            'legislação de propriedade intelectual. É vedada a reprodução, cópia ou uso não autorizado.',
        },
      ],
    },
    {
      title: 'Limitação de responsabilidade',
      blocks: [
        {
          type: 'p',
          text:
            `Dentro dos limites permitidos pela legislação aplicável, a ${COMPANY.tradeName} não se ` +
            'responsabiliza por:',
        },
        {
          type: 'list',
          items: [
            'A prestação do serviço de seguro e assistência, que é de responsabilidade da seguradora;',
            'Coberturas negadas, sinistros não indenizados ou divergências relativas à apólice;',
            'Informações de preço e cobertura fornecidas e atualizadas pelas seguradoras parceiras;',
            'Indisponibilidades, falhas ou interrupções temporárias da plataforma decorrentes de fatores técnicos ou de terceiros;',
            'Danos decorrentes do uso indevido da plataforma pelo usuário ou de informações incorretas por ele fornecidas.',
          ],
        },
      ],
    },
    {
      title: 'Disponibilidade e alterações do serviço',
      blocks: [
        {
          type: 'p',
          text:
            `A ${COMPANY.tradeName} empenha-se em manter a plataforma disponível, mas não garante ` +
            'funcionamento ininterrupto ou livre de erros, podendo realizar manutenções, atualizações ou ' +
            'suspensões a qualquer tempo. As seguradoras parceiras, os preços e as coberturas exibidos podem ' +
            'ser alterados ou descontinuados sem aviso prévio.',
        },
      ],
    },
    {
      title: 'Proteção de dados pessoais',
      blocks: [
        {
          type: 'p',
          text:
            'O tratamento de dados pessoais realizado pela plataforma é regido pela nossa Política de ' +
            'Privacidade, disponível em ' +
            `${COMPANY.domain}/politica-de-privacidade, que integra estes Termos.`,
        },
      ],
    },
    {
      title: 'Alterações destes Termos',
      blocks: [
        {
          type: 'p',
          text:
            `A ${COMPANY.tradeName} poderá alterar estes Termos a qualquer momento, publicando a versão ` +
            'atualizada nesta página com a respectiva data de atualização. O uso continuado da plataforma ' +
            'após a alteração representa concordância com os novos Termos.',
        },
      ],
    },
    {
      title: 'Legislação aplicável e foro',
      blocks: [
        {
          type: 'p',
          text:
            'Estes Termos são regidos pelas leis brasileiras, em especial o Código de Defesa do Consumidor ' +
            '(Lei nº 8.078/1990), o Marco Civil da Internet (Lei nº 12.965/2014) e a Lei Geral de Proteção ' +
            'de Dados (Lei nº 13.709/2018).',
        },
        {
          type: 'p',
          text:
            `Fica eleito o foro da comarca de ${COMPANY.jurisdiction} para dirimir eventuais controvérsias, ` +
            'sem prejuízo do foro de domicílio do consumidor, quando aplicável nos termos da lei.',
        },
        {
          type: 'p',
          text:
            `Dúvidas sobre estes Termos podem ser encaminhadas para ${COMPANY.supportEmail} ou pelo ` +
            `WhatsApp ${COMPANY.supportWhatsapp}.`,
        },
      ],
    },
  ],
};
